<template lang="pug">
.bloco-alerta-visualizar-monitoramento-agricola
    .alerta-bloco
        .alerta-bloco--icone
            i.mdi.mdi-alert-outline.mdi-36px

        .alerta-bloco--conteudo
            .bloco-links
                ul
                    li
                        a(
                            @click='atualizarInfoAlertas("DIA")',
                            :class='tempoAlertas === "DIA" ? "ativo" : ""'
                        ) Hoje
                    li
                        a(
                            @click='atualizarInfoAlertas("SEMANA")',
                            :class='tempoAlertas === "SEMANA" ? "ativo" : ""'
                        ) Últimos 7 dias
                    li
                        a(
                            @click='atualizarInfoAlertas("MES")',
                            :class='tempoAlertas === "MES" ? "ativo" : ""'
                        ) Últimos 30 dias
                    li
                        a(
                            @click='atualizarInfoAlertas("TODO")',
                            :class='tempoAlertas === "TODO" ? "ativo" : ""'
                        ) Todo período

            .bloco-dados
                .bloco-interno
                    span {{ quantidadeAlertas }}
                    .bloco-interno--texto Alerta encontrado no território monitorado.
                    a.bloco-interno--detalhes(
                        @click='abrirModalAlertaDetalhes()'
                    ) Ver Detalhes
    ModalVisualizarDetalhesAlerta(
        :show='mostrarModalDetalhesAlerta',
        :codigoAreaMonitorada='codigoAreaMonitorada',
        @voltar='mostrarModalDetalhesAlerta = false'
    )
</template>

<script>
import MonitoramentoAgricolaService from '@/services/MonitoramentoAgricolaService';
import ModalVisualizarDetalhesAlerta from './ModalVisualizarDetalhesAlerta.vue';

export default {
    name: 'BlocoAlertaVisualizarMonitoramentoAgricola',
    props: {
        codigoAreaMonitorada: {
            type: String,
            default: () => null
        }
    },

    components: {
        ModalVisualizarDetalhesAlerta
    },

    data() {
        return {
            tempoAlertas: 'DIA',
            alertas: null,
            mostrarModalDetalhesAlerta: false,
            dados: {
                agricola: [],
                totalItens: 0,
                totalPaginas: 0
            }
        };
    },

    computed: {
        quantidadeAlertas() {
            if (!this.alertas) {
                return '-';
            }

            if (this.tempoAlertas === 'DIA') {
                return this.alertas.totalDiario;
            }

            if (this.tempoAlertas === 'SEMANA') {
                return this.alertas.totalSemanal;
            }

            if (this.tempoAlertas === 'MES') {
                return this.alertas.totalMensal;
            }

            return this.alertas.total;
        }
    },

    async mounted() {
        this.getResumo();
    },

    methods: {
        getResumo() {
            MonitoramentoAgricolaService.buscarResumoAlertasAgricolas(
                this.codigoAreaMonitorada
            )
                .then(({ data }) => {
                    this.alertas = data;
                })
                .catch(error => {
                    this.$notify.error({
                        message: 'Não foi possível exibir os dados de alertas.'
                    });
                    throw error;
                });
        },

        atualizarInfoAlertas(tempo) {
            this.tempoAlertas = tempo;
        },

        abrirModalAlertaDetalhes() {
            this.mostrarModalDetalhesAlerta = true;
        }
    }
};
</script>

<style lang="scss" scoped>
.alerta-bloco {
    background: #ef99181a;
    display: flex;
    justify-content: flex-start;
    border-radius: 8px;
    align-items: center;

    .alerta-bloco--conteudo {
        padding: 5px 8px;

        .bloco-links {
            height: 100%;
            display: flex;
            align-items: center;

            ul {
                margin: 0;
                padding: 0;
                display: flex;

                li {
                    list-style: none;
                    margin-right: 25px;
                    padding: 7px;
                    color: var(--primary);

                    a:not(.ativo) {
                        cursor: pointer;
                        text-decoration: none;
                    }
                    a:hover {
                        cursor: pointer;
                    }
                    a.ativo:hover {
                        text-decoration: underline;
                        text-decoration-color: var(--warning);
                        text-underline-offset: 5px;
                        text-decoration-thickness: 2px;
                    }
                }
            }
        }
        .bloco-dados {
            margin: 0 8px;

            .bloco-interno {
                display: flex;
                align-items: baseline;
                height: 100%;
                font-weight: 600;
                padding-top: 5px;
                flex-wrap: wrap;

                span {
                    font-size: 22px;
                    color: #3b3b3b;
                    margin-right: 10px;
                }

                a {
                    margin-left: 10px;
                    cursor: pointer;
                    color: rgba(9, 111, 231, 1);
                    font-weight: 400;
                    font-family: Roboto;
                }
            }
        }
    }
    .alerta-bloco--icone {
        background: var(--warning);
        width: 77px;
        height: 77px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        color: var(--white);
    }

    .ativo {
        font-weight: bold;
        text-decoration: underline;
        text-decoration-color: var(--warning);
        text-underline-offset: 5px;
        text-decoration-thickness: 2px;
    }
}
</style>
